var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 17.5C35 27.1649 27.1649 35 17.5 35C7.83501 35 0 27.1649 0 17.5C0 7.83501 7.83501 0 17.5 0C27.1649 0 35 7.83501 35 17.5ZM24.553 12.1969C25.0656 12.7095 25.0656 13.5405 24.553 14.053L15.803 22.803C15.2905 23.3156 14.4596 23.3156 13.9469 22.803L10.4469 19.303C9.93436 18.7905 9.93436 17.9595 10.4469 17.447C10.9595 16.9344 11.7905 16.9344 12.3031 17.447L14.875 20.0188L18.7859 16.1079L22.697 12.1969C23.2095 11.6844 24.0405 11.6844 24.553 12.1969Z",
    fill: "#3DC8AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e0d74aff8489e8dd9169c489e873d8ff.svg";
export { ForwardRef as ReactComponent };